// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"401":"cd2e7fdf","504":"55eb1dc1"}[chunkId] + ".chunk.js";
};